import styled from 'src/style';
import { Paragraph } from '../Typography';
import { mediaQueries } from 'src/style/breakpoints';
import colors from 'src/style/colors';

export const IconContainer = styled.div({
  display: 'flex',
  justifyContent: 'flex-end',
  alignItems: 'center',
  width: 50,
  height: 50,
  marginLeft: 40,
});

export const QAContainer = styled.div({
  backgroundColor: colors.lightGrey,
  marginBottom: 10,
  borderRadius: 5,
});

export const QuestionContainer = styled.div({
  display: 'flex',
  flexDirection: 'row',

  justifyContent: 'space-between',
  alignItems: 'center',
  cursor: 'pointer',
  padding: '15px 40px 15px 40px',
  [mediaQueries.phoneOnly]: {
    padding: '5px 30px 5px 30px',
  },
});

export const Answer = styled(Paragraph)({
  padding: '0px 40px 35px 40px',
  [mediaQueries.phoneOnly]: {
    padding: '5px 30px 35px 30px',
  },
  '& a': {
    color: colors.purple,
    textDecoration: 'none',
  },
});
